module.exports = __webpack_public_path__ + "img/notebook-check-outline.d7782820.svg";